const telnumberRegExp = /^1[3-9]\d{9}$/ // 国内手机号码的正则表达式
const emailRegExp =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
// 邮箱的正则表达式

export { telnumberRegExp, emailRegExp }
